/**
 * @file LicenseQuickFilter.styles.ts
 * @desc Styles for the LicenseQuickFilter component
 * @copyright All rights reserved @ Inarix
 */

import { SxProps, Theme } from "@mui/material";

export const BG_CONTAINER = "#e8e8e8";

export const containerSx: SxProps<Theme> = {
  display: "inline-flex",
  gap: 0.5,
  mb: 1.5,
  backgroundColor: BG_CONTAINER,
  borderRadius: "6px",
  p: "4px",
};

export const labelBoxSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 0.75,
};

export const countBadgeSx = (bg: string, color: string): SxProps<Theme> => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 20,
  height: 20,
  borderRadius: "10px",
  px: 0.75,
  fontSize: "0.7rem",
  fontWeight: 700,
  backgroundColor: bg,
  color,
});

export const chipSx = (isSelected: boolean): SxProps<Theme> => ({
  borderRadius: "6px",
  border: "none",
  backgroundColor: isSelected ? "#ffffff" : BG_CONTAINER,
  boxShadow: isSelected ? "0 1px 4px rgba(0,0,0,0.18)" : "none",
  height: 32,
  cursor: "pointer",
  transition: "background-color 0.2s, box-shadow 0.2s",
  "& .MuiChip-label": { px: 1.5 },
  "&:hover": {
    backgroundColor: isSelected ? "#ffffff" : "#dedede",
  },
});

export const labelTextStyle = (isSelected: boolean): React.CSSProperties => ({
  fontWeight: isSelected ? 600 : 400,
  color: isSelected ? "#212121" : "#616161",
});
